// Browser-vs-SSR is frozen at first import. Tests that delete
// globalThis.window after this module loads will not reach the SSR branches.
const browserWindow: Window | null =
  "window" in globalThis ? (globalThis.window ?? null) : null;

export function getBrowserWindow(): Window | null {
  return browserWindow;
}

export function getBrowserDocument(): Document | null {
  return browserWindow?.document ?? null;
}

export function getBrowserNavigator(): Navigator | null {
  return browserWindow?.navigator ?? null;
}

export function getNodeProcess(): NodeJS.Process | undefined {
  if (!("process" in globalThis)) return undefined;
  return globalThis.process;
}
